'use client';

import LandingLayout from '@/components/LandingLayout';
import {
  ExclamationTriangleIcon,
  HomeIcon,
} from '@heroicons/react/24/outline';
import Link from 'next/link';
import { Helmet } from 'react-helmet-async';

export default function AppNotFound() {
  return (
    <LandingLayout>
      <Helmet>
        <title>Page Not Found | Greet Dashboard</title>
        <meta name="description" content="The page you're looking for doesn't exist." />
      </Helmet>
      
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
        {/* 404 Icon */}
        <div className="flex justify-center mb-6">
          <ExclamationTriangleIcon className="h-16 w-16 text-blue-600" />
        </div>
        
        {/* 404 Text */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
        
        {/* Error Message */}
        <h2 className="text-xl font-semibold text-gray-700 mb-4">
          Page Not Found
        </h2>
        
        <p className="text-gray-600 mb-8 max-w-md leading-relaxed">
          The page you're looking for doesn't exist. It might have been moved or you entered the wrong URL.
        </p>
        
        {/* Action Buttons */}
        <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center mb-8">
          <Link
            href="/app"
            className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          >
            <HomeIcon className="h-5 w-5 mr-2" />
            Go to Dashboard
          </Link>
        </div>
      </div>
    </LandingLayout>
  );
} 